/*****
  'is-previous' and 'is-next' classes for Flickity carousels
*****/
Flickity.createMethods.push('_createPrevNextCells');
Flickity.prototype._createPrevNextCells = function () {
  this.on('select', this.setPrevNextCells);
}
Flickity.prototype.setPrevNextCells = function () {
  // remove classes
  changeSlideClasses(this.previousSlide, 'remove', 'is-previous');
  changeSlideClasses(this.nextSlide, 'remove', 'is-next');

  // set slides
  if (this.selectedIndex - 1 < 0) {
    this.previousSlide = this.slides[this.slides.length - 1];
  } else {
    this.previousSlide = this.slides[this.selectedIndex - 1];
  }

  if (this.selectedIndex + 1 === this.slides.length) {
    this.nextSlide = this.slides[0];
  } else {
    this.nextSlide = this.slides[this.selectedIndex + 1];
  }

  // add classes
  changeSlideClasses(this.previousSlide, 'add', 'is-previous');
  changeSlideClasses(this.nextSlide, 'add', 'is-next');
}
function changeSlideClasses(slide, method, className) {
  if (!slide) {
    return;
  }

  slide.getCellElements().forEach(function (cellElem) {
    cellElem.classList[method](className);
  })
}


(function ($) {
  $(function () {

    /*****
      Flickity
    *****/
    if ($('.carousel').length) {
      $('.carousel').flickity({
        cellSelector: '.carousel-item',
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        autoPlay: 5000,
        wrapAround: true,
        imagesLoaded: true
      });

      // A small hack to recalculate the size of the carousel
      $('.carousel').flickity('resize');
      setTimeout(function () {
        $('.carousel').flickity('resize');
      }, 300);

      // Go to the previous item
      $('.carousel .prev').on('click', function (e) {
        e.preventDefault();
        var parent = $('.carousel');
        parent.flickity('previous');
      });

      // Go to the next item
      $('.carousel .next').on('click', function (e) {
        e.preventDefault();
        var parent = $('.carousel');
        parent.flickity('next');
      });
    }
    
    
    /*****
      Team carousel
    *****/
    if ($('.team-modal-carousel').length) {
      $('.team-modal-carousel').flickity({
        cellSelector: '.team-modal-slide',
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: false,
        wrapAround: true,
        imagesLoaded: true
      });

      // A small hack to recalculate the size of the carousel
      $('.team-modal-carousel').flickity('resize');
      setTimeout(function () {
        $('.team-modal-carousel').flickity('resize');
      }, 300);

      // Go to the previous item
      $('.team-modal-carousel .read-more-link.prev').on('click', function (e) {
        e.preventDefault();
        var parent = $('.team-modal-carousel');
        parent.flickity('previous');
      });

      // Go to the next item
      $('.team-modal-carousel .read-more-link.next').on('click', function (e) {
        e.preventDefault();
        var parent = $('.team-modal-carousel');
        parent.flickity('next');
      });

      $('.team-people-item').on('click', function(e){
        e.preventDefault();
        var key = parseInt($(this).attr('data-modal-id'));
        var slug = $(this).attr('data-slug');
        history.replaceState(null, null, '#' + slug);
        $('.team-modal-carousel').flickity('select', key, true, true);
        $('.team-modal-carousel').addClass('is-open');
      });
      
      $('.team-modal-close').on('click', function(e){
        e.preventDefault();
        $('.team-modal-carousel').removeClass('is-open');
        history.replaceState(null, null, ' ');
      });
      $('svg[data-icon="close"]').on('click', function(e){
        e.preventDefault();
        $('.team-modal-carousel').removeClass('is-open');
        history.replaceState(null, null, ' ');
      });

      $('.team-modal-carousel').on('change.flickity', function(event, index) {
        var newSlug = $('.team-modal-slide').eq(index).attr('data-slug');
        history.replaceState(null, null, '#' + newSlug);
      });

      if (window.location.hash) {
        var theHash = window.location.hash.replace('#', '');
        var slideTrigger = $('.team-people-item[data-slug="'+ theHash +'"]');
        if (slideTrigger.length) {
          slideTrigger.click();
        }
      }
    }


  });
})(jQuery);
